import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import queryKeys from './queryKeys';
import QueryKeys from '@murphy-frontend/common/api/Users/QueryKeys';
import { useInjection } from '@murphy-frontend/common/contexts/InversifyContext';
import TrainingApiType, { CustomerTrainingSettingRequest, TrainingApi, } from "./TrainingApi"

export const updateCustomerTrainingSettings = (translations: Record<string, string>) => {
  const trainingApi = useInjection<TrainingApi>(TrainingApiType.TrainingApiType)
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      customerId,
      trainingId,
      mandatoryForUsers,
      mandatoryForAdmins
    }: {
      customerId: string,
      trainingId: number,
      mandatoryForUsers: boolean,
      mandatoryForAdmins: boolean
    }) => {
      const request: CustomerTrainingSettingRequest = {
        MandatoryForUsers: mandatoryForUsers,
        MandatoryForAdmins: mandatoryForAdmins
      };

      return trainingApi.updateCustomerTrainingSettings(customerId, trainingId, request);
    },
    onError: (error: AxiosError) => {
      if (error.response && error.response.data && typeof error.response.data === 'string') {
        toast.error(error.response.data);
      } else {
        toast.error('Unknown error');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.all });
      toast.success(`${translations.course} ${translations.updated}`);
    },
  });
};